(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuja-support-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fuja-support-carousel')) {
    customElements.define('fuja-support-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.fuja-support__track');
        this.controls = this.querySelector('.fuja-support__controls');
        this.previous = this.querySelector('[data-step="-1"]');
        this.next = this.querySelector('[data-step="1"]');
        if (!this.track || !this.controls) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.addEventListener('scroll', () => this.queueUpdate(), { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            const left = event.key === 'Home' ? 0 : this.track.scrollWidth * (this.rtl ? -1 : 1);
            this.track.scrollTo({ left, behavior: this.behavior() });
          }
        }, { signal });
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-step]');
          if (button) this.move(Number(button.dataset.step));
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const blockId = event.detail?.blockId;
          const card = [...this.track.children].find(item => item.dataset.blockId === blockId);
          if (!card) return;
          const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          const aligned = this.rtl ? left + card.clientWidth - this.track.clientWidth : left;
          this.track.scrollTo({ left: aligned, behavior: 'auto' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          this.rtl = getComputedStyle(this.track).direction === 'rtl';
          this.queueUpdate();
        });
        this.resizeObserver.observe(this.track);
        this.mutationObserver = new MutationObserver(() => this.queueUpdate());
        this.mutationObserver.observe(this.track, { childList: true });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      behavior() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(step) {
        const cards = [...this.track.children];
        const first = cards[0];
        if (!first) return;
        const distance = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.track.scrollBy({ left: distance * step * (this.rtl ? -1 : 1), behavior: this.behavior() });
      }
      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }
      update() {
        const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.min(limit, Math.abs(this.track.scrollLeft));
        this.controls.hidden = limit < 2;
        this.previous.hidden = position < 2;
        this.next.hidden = position >= limit - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
